import { Alert, Button, Form, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";

const CustomModal = (props: any) => {
  const [inputValue, setInputValue] = useState("");
  const handleDelete = () => {
    if (props?.title === "Transaction") {
      props.onDelete(inputValue);
      setInputValue("");
    } else {
      props?.onDelete();
    }
  };
  return (
    <Modal
      open={props?.isModalOpen}
      onCancel={props?.handleCancel}
      footer={null}
      closable={false}
      centered
    >
      <div>
        <Alert
          message={`${props?.type} ${props?.title}`}
          description={`Are you sure you want to ${props?.type} this ${props?.title}?`}
          type="warning"
          showIcon
          className="mb-4"
        />
        {props?.title === "Transaction" && (
          <Form>
            <Form.Item label="Remarks" labelCol={{ span: 24 }}>
              <TextArea
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </Form.Item>
          </Form>
        )}

        <Row>
          <Col md={{ span: 7, offset: 5 }}>
            <div className="d-flex gap-2">
              <Button block onClick={props?.handleCancel} className="me-2">
                Cancel
              </Button>
              <Button
                block
                danger
                onClick={handleDelete}
                disabled={props?.title === "Transaction" && !inputValue.trim()}
              >
                Yes, {props?.type}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default CustomModal;
